var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.sliderItems.length
    ? _c(
        "section",
        {
          staticClass: "d-flex flex-column",
          class: _setup.isMobile ? "ga-4" : "ga-6",
          attrs: { id: "documents", "data-qa": "lpu_documents" },
        },
        [
          _c(
            "h2",
            {
              staticClass: "text--text",
              class: _setup.isMobile ? "text-h6" : "text-h5",
              attrs: { "data-qa": "lpu_documents_title" },
            },
            [_vm._v("\n    " + _vm._s(_setup.tStatic("Документы")) + "\n  ")]
          ),
          _vm._v(" "),
          _c(_setup.CoreImageSlider, {
            style: {
              minHeight: "240px",
            },
            attrs: { items: _setup.sliderItems },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }